import { render } from "./app-layout-main.vue?vue&type=template&id=3ad1834c"
import script from "./app-layout-main.vue?vue&type=script&lang=js"
export * from "./app-layout-main.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/layout/app-layout-main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ad1834c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ad1834c', __exports__)) {
    console.log('reload')
    api.reload('3ad1834c', __exports__)
  }
  
  module.hot.accept("./app-layout-main.vue?vue&type=template&id=3ad1834c", () => {
    console.log('re-render')
    api.rerender('3ad1834c', render)
  })

}


export default __exports__